var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "block-icon-share"
    ),
    React.createElement(
      "g",
      { id: "Layer_2", "data-name": "Layer 2" },
      React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M38.87 29.75a9.11 9.11 0 0 0-7 3.32L18 26.28a8.85 8.85 0 0 0 0-4.56l13.87-6.79a9.13 9.13 0 1 0-2.08-5.8v.7L15 17.05A9.13 9.13 0 1 0 15 31l14.75 7.22v.7a9.13 9.13 0 1 0 9.13-9.13z", id: "Layer_1-2", "data-name": "Layer 1" })
    )
  );
});